import { env } from 'config/env';

const APP_ID = env.appId;

/**
 *
 * @param key the storage key
 * @returns hashed, unique key
 *
 * Use this function to obscure the LS/SS etc keys
 */
export function hashKey(key: string): string {
  let hash = 5381;

  for (let i = 0; i < key.length; i++) {
    hash = (hash * 33) ^ key.charCodeAt(i);
  }

  const finalHash = hash >>> 0;

  return `${APP_ID}.${finalHash}`;
}
